__turbopack_context__.v({
  "cardAnimation": "expertiseScroll-module__Toddhq__cardAnimation",
  "fadeInUp": "expertiseScroll-module__Toddhq__fadeInUp",
  "headerAnimation": "expertiseScroll-module__Toddhq__headerAnimation",
  "sectionAnimation": "expertiseScroll-module__Toddhq__sectionAnimation",
});
